/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * QuestionAnswersBase
 * auto generated base class for the model QuestionAnswersModel.
 */
export const QuestionAnswersModelBase = ModelBase.named('QuestionAnswers')
  .props({
    __typename: types.optional(types.literal('QuestionAnswers'), 'QuestionAnswers'),
    answers: types.union(types.undefined, types.array(types.string)),
    footer: types.union(types.undefined, types.null, types.string),
    id: types.union(types.undefined, types.number),
    question: types.union(types.undefined, types.string),
    subtitle: types.union(types.undefined, types.null, types.string),
    type: types.union(types.undefined, types.string),
    values: types.union(types.undefined, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class QuestionAnswersModelSelector extends QueryBuilder {
  get answers() {
    return this.__attr('answers')
  }
  get footer() {
    return this.__attr('footer')
  }
  get id() {
    return this.__attr('id')
  }
  get question() {
    return this.__attr('question')
  }
  get subtitle() {
    return this.__attr('subtitle')
  }
  get type() {
    return this.__attr('type')
  }
  get values() {
    return this.__attr('values')
  }
}
export function selectFromQuestionAnswers() {
  return new QuestionAnswersModelSelector()
}

export const questionAnswersModelPrimitives = selectFromQuestionAnswers().answers.footer.question.subtitle.type.values
